var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8083 7.03267C20.6892 7.41767 20.625 7.8265 20.625 8.25C20.625 9.009 21.241 9.625 22 9.625H30.25C30.6147 9.625 30.9644 9.48013 31.2223 9.22227C31.4801 8.96441 31.625 8.61467 31.625 8.25C31.6251 7.83734 31.5633 7.42699 31.4417 7.03267M20.8083 7.03267C21.0687 6.19061 21.5919 5.45405 22.3011 4.93082C23.0104 4.4076 23.8686 4.12521 24.75 4.125H27.5C29.3553 4.125 30.9228 5.34967 31.4417 7.03267M20.8083 7.03267C20.119 7.07483 19.4333 7.12433 18.7477 7.17933C16.6742 7.35167 15.125 9.11717 15.125 11.198V15.125M31.4417 7.03267C32.131 7.07483 32.8167 7.12433 33.5023 7.17933C35.5758 7.35167 37.125 9.11717 37.125 11.198V30.25C37.125 31.344 36.6904 32.3932 35.9168 33.1668C35.1432 33.9404 34.094 34.375 33 34.375H28.875M15.125 15.125H8.9375C7.799 15.125 6.875 16.049 6.875 17.1875V37.8125C6.875 38.951 7.799 39.875 8.9375 39.875H26.8125C27.951 39.875 28.875 38.951 28.875 37.8125V34.375M15.125 15.125H26.8125C27.951 15.125 28.875 16.049 28.875 17.1875V34.375M13.75 28.875L16.5 31.625L22 24.75",
    stroke: "#FEDA14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/registered.1ba6a6851dba68b08a251ff83d335635.svg";
export { ForwardRef as ReactComponent };